import React, { useCallback, useEffect, useRef, useState } from "react";
import { BOT_CONV_MESSAGE_TYPE } from "../../helpers/consts/common-consts";
import { defaultChatBotSettings } from "../../consts/settings";
import BotMessageFactory from "../question-ask/bot-message/bot-message-factory";
import RetrievedContext from "../question-ask/conv-message/citation/retrieved-context";

export default function ChatConversation(props) {
  const messageRef = useRef(null);
  const settings = props.chatBotSetting || defaultChatBotSettings;

  // An inline [n] clicked in the answer, for the source list to open at n.
  const [citationFocus, setCitationFocus] = useState(null);
  const onCitationClick = useCallback(
    number => setCitationFocus(focus => ({ number, nonce: (focus?.nonce || 0) + 1 })),
    []
  );

  useEffect(() => {
    messageRef.current?.scrollIntoView?.({
      block: props.senderType === BOT_CONV_MESSAGE_TYPE ? "start" : "end",
    });
  }, [props.message, props.senderType]);

  return (
    <div ref={messageRef} className="chat-message">
      {props.senderType === BOT_CONV_MESSAGE_TYPE ? (
        <div className="chat-message-row">
          <div className="chat-message-avatar">
            <img src={settings.logo || defaultChatBotSettings.logo} alt="Assistant" />
          </div>
          <div className="chat-message-content">
            <div className="chat-message-author">AI Agent</div>
            <BotMessageFactory {...props} onCitationClick={onCitationClick} />
            {/* Here rather than in each renderer, so no message type can drop
                its sources. */}
            <RetrievedContext context={props.metadata?.retrievedContext} focus={citationFocus} />
          </div>
        </div>
      ) : (
        <div className="chat-message-row justify-end">
          <div className="chat-user-bubble">
            <p>{props.message}</p>
          </div>
        </div>
      )}
    </div>
  );
}
